<template>
  <div v-if="isfeaturedStory" class="featured-story">Featured Story</div>
</template>

<script>
export default {
  name: 'CIS-Resource-PagedListing-Newsletter',
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    isfeaturedStory() {
      return this.item.featuredStory?.value || false;
    }
  }
};
</script>

<style lang="scss" scoped>
.featured-story {
  display: inline-block;
  background: linear-gradient(
    169deg,
    rgba(0, 0, 0, 1) 0%,
    rgba(0, 59, 92, 1) 20%,
    rgba(0, 134, 191, 1) 100%
  );
  padding: 0.2rem 0.8rem 0.3rem 0.8rem;
  @include font-styles('Arial', 1.4rem, 500, normal, normal, 0.1rem, $white);
  text-transform: uppercase;
}
</style>
